// Row-count constants shared by the row picker (main bundle) and the pdf
// chunk. Lives in its own module with NO react-pdf import so the picker can
// use them without pulling the lazy pdf chunk in with it. The page count a
// row choice produces is no longer estimated from constants: the picker
// plans the real rows with src/pdf/pagePlan.ts (through the pdf chunk's
// measurer), the same plan the document prints.

// The out-of-the-box choice: about four landscape pages of a one-line table.
export const DEFAULT_PDF_ROWS = 50;

// Most rows a log PDF may contain. Higher than the page's own 250-row display
// cap, so choosing more than the table shows triggers a one-off fetch with
// `row_limit` at download time (routine page loads stay at 250). Must match
// EXPORT_ROWS_LIMIT in the server's controllers/analytics.ts, which clamps
// the same value. 1000 rows is about 60 landscape pages and a couple of
// seconds of blocked main thread; past that the PDF stops being a document
// anyone reads, and Excel (which is uncapped) is the right export.
export const MAX_PDF_ROWS = 1000;
